<template>
  <router-link class="Drop-Menu-Item" :to="{name: PATHS_NAME.KNOWLEDGE_BASE}" @click="toClose"> 
    База знаний
  </router-link>
</template>

<script setup>
  import { PATHS_NAME } from "@shared/routers/consts/pathsName";
  //------------------------------------------
  import UserProfile from "@svg/UserProfile.vue";
  //------------------------------------------
  const emit = defineEmits(['close-menu']);
  //------------------------------------------
  //Закрыть дропдаун
  const toClose = () => emit('close');
</script>

<style lang="scss">
  @import '../../../../styles/Drop-Menu-Item.scss';
</style>
